import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { Router } from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { switchAll } from 'rxjs';
import Swal from 'sweetalert2';
import { BrowserModule } from '@angular/platform-browser'
import { CommonModule } from '@angular/common'

@Component({
  selector: 'app-testimonial',
  templateUrl: './testimonial.component.html',
  styleUrls: ['./testimonial.component.css']
})
export class TestimonialComponent implements OnInit {
  li:any;
  list=[];
  constructor(private http: HttpClient) { }

  ngOnInit(): void {

    this.http.get('https://api3.ecell.in/eureka22/testimonials/')
    .subscribe(Response => {
      if(Response){ }
      this.li=Response;
      this.list=this.li.testi;
      // console.log(this.list)
    });
  }

}
